import { CircularProgress } from '@mui/material';
import { JSX } from 'react';

type Props = {
  loading: boolean;
}
export const Loader = ({ loading }: Props): JSX.Element => {
  return loading ? <CircularProgress /> : <></>;
};
